import React, { useState, useRef, useEffect } from "react";
import "../styles/NewConversions.css";
import {
    useNavigate,
  Link,
  useLocation
} from "react-router-dom";

/* ─── Icons ─── */
const LayoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" />
  </svg>
);
const RepeatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const CreditCardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);
const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
const HelpIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const UploadCloudIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 16 12 12 8 16" /><line x1="12" y1="12" x2="12" y2="21" />
    <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
  </svg>
);
const ArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
  </svg>
);
const CloseIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const PlayIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);
const BackIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
  </svg>
);
const InfoIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);
const ChevronDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const CONVERSION_TYPES = [
  {
    value: "as_is",
    label: "AS-IS conversion",
    description: "Convert without applying cleanup.",
  },
  {
    value: "cleaned",
    label: "Cleaned Conversion",
    description: "Apply cleanup during conversion.",
  },
  {
    value: "advanced",
    label: "Advanced Conversion",
    description: "Apply advanced processing during conversion.",
  },
];

/* ─── Data ─── */
const NAV_ITEMS = [
  { label: "Dashboard", icon: <LayoutIcon />, active: false,path: "/dashboard" },
  { label: "Conversions", icon: <RepeatIcon />, active: true,path: "/conversions" },
  { label: "Payments", icon: <CreditCardIcon />, active: false,path: "/payments" },
  { label: "Settings", icon: <SettingsIcon />, active: false,path: "/settings" },
  { label: "Help", icon: <HelpIcon />, active: false,path: "/help" },
];

  const FORMAT_OPTIONS = {
    Documents: ["PDF", "DOCX", "TXT", "XLSX", "ODT", "EPUB", "RTF", "HTML"],
    Images: ["PNG", "JPG", "SVG", "WEBP", "GIF", "HEIC", "TIFF", "BMP"],
    Video: ["MP4", "AVI", "MOV", "MKV", "WEBM", "FLV", "WMV"],
    Audio: ["MP3", "WAV", "FLAC", "AAC", "OGG", "M4A", "WMA"],
    Archives: ["ZIP", "RAR", "7Z", "TAR", "GZ"],
    Data: ["CSV", "JSON", "XML", "YAML", "SQL", "TSV"],
  };

/* ─── Toggle Switch ─── */
function Toggle({ checked, onChange }) {
  return (
    <button className="nc-toggle" onClick={() => onChange(!checked)}
      role="switch" aria-checked={checked}
      style={{ background: checked ? "#2563EB" : "#CBD5E1" }}>
      <span className="nc-toggle-knob" style={{ transform: checked ? "translateX(20px)" : "translateX(0)" }} />
    </button>
  );
}

/* ─── Sidebar ─── */
function Sidebar() {
    const location = useLocation();
    const navigate = useNavigate();
    const currentUser = JSON.parse(
        localStorage.getItem("currentUser") || "{}"
    );

    const fullName = currentUser?.full_name || "User";
    const email = currentUser?.email || "";

    const initials = fullName
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

    const handleLogout = () => {
                  localStorage.removeItem("currentUser");
                  localStorage.removeItem("selectedPlan");
                  navigate("/");
                };

  return (
    <aside className="nc-sidebar">
      <div className="nc-sidebar-upper">
        <div className="nc-profile">
        <div className="nc-avatar">
        {initials}
        </div>
        <div className="nc-profile-info">
        <span className="nc-profile-name">
        {fullName}
        </span>
        <span className="nc-profile-role">
        {email}
        </span>
        </div>
        </div>
        <nav className="nc-nav">
          {NAV_ITEMS.map((item) => (
                                                      <Link
                                                        key={item.label}
                                                        to={item.path}
                                                        className={`db-nav-item ${
                                                          location.pathname === item.path
                                                            ? "db-nav-item--active"
                                                            : ""
                                                        }`}
                                                      >
                                                        <span className="db-nav-icon">
                                                          {item.icon}
                                                        </span>
                                                        {item.label}
                                                      </Link>
                                                    ))}
                                                {/* ─── Logout separator + button ─── */}
                                                                                                                              <div className="db-nav-separator" />
                                                                                                                              <button className="db-nav-item db-nav-logout" onClick={handleLogout}>
                                                                                                                                <span className="db-nav-icon">
                                                                                                                                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E24646" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                                                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                                                                                                                    <polyline points="16 17 21 12 16 7" />
                                                                                                                                    <line x1="21" y1="12" x2="9" y2="12" />
                                                                                                                                  </svg>
                                                                                                                                </span>
                                                                                                                                Log Out
                                                                                                                              </button>
        </nav>
      </div>
    </aside>
  );
}

/* ─── Main Content ─── */
function MainContent() {

    const API_URL = process.env.REACT_APP_API_URL;
  const [emailNotify, setEmailNotify] = useState(true);
  const [autoDownload, setAutoDownload] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [conversionMessage, setConversionMessage] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");


  const removeFile = (id) => setFiles(files.filter((f) => f.id !== id));
  const updateTarget = (id, format) =>
    setFiles(files.map((f) => (f.id === id ? { ...f, to: format } : f)));

  const [conversionType, setConversionType] = useState("as_is");

  const [subscription, setSubscription] = useState(null);

  useEffect(() => {

    const currentUser = JSON.parse(
      localStorage.getItem("currentUser") || "{}"
    );

    if (!currentUser?.user_id) return;

    fetch(
      `${API_URL}/subscription/${currentUser.user_id}`
    )
      .then((res) => res.json())
      .then((data) => setSubscription(data))
      .catch(console.error);

  }, [API_URL]);

    const getAvailableConversionTypes = () => {

      // Free User
      if (!subscription) {

        return ["as_is"];
      }

      // Basic Plan
      if (subscription.plan_id === 1) {

        return [
          "as_is",
          "cleaned"
        ];
      }

      // Standard Plan
      if (subscription.plan_id === 2) {

        return [
          "as_is",
          "cleaned",
          "advanced"
        ];
      }

      // Premium / Enterprise

      return [
        "as_is",
        "cleaned",
        "advanced"
      ];
    };

    const availableConversions =
      getAvailableConversionTypes();

  const selectedConversionType = CONVERSION_TYPES.find(
    (option) => option.value === conversionType
  );

    const PREMIUM_FORMATS = [
      "SQL"
      , "HL7 v2.x"
      , "HL7 v3"
      , "CCD"
      , "CDA"
      , "FHIR"
      , "ODT"
      , "EPUB"
      , "RTF"
      , "PNG"
      , "JPG"
      , "SVG"
      , "WEBP"
      , "GIF"
      , "HEIC"
      , "TIFF"
      , "BMP"
      , "MP4"
      , "AVI"
      , "MOV"
      , "MKV"
      , "WEBM"
      , "FLV"
      , "WMV"
      , "MP3"
      , "WAV"
      , "FLAC"
      , "AAC"
      , "OGG"
      , "M4A"
      , "WMA"
      , "ZIP"
      , "RAR"
      , "7Z"
      , "TAR"
      , "GZ"
      , "EDI Purchasing"
      , "EDI Logistics"
      , "EDI Invoicing"
      , "EDI Inventory"
      , "EDI Manufacturing"
      , "EDI Insurance"
      , "EDI Finance"
      , "EDI Acknowledgements"
      , "Parquet"
      , "Avro"
      , "ORC"
      , "RC"
    ];

    const isPremiumFormat = (format) =>
      PREMIUM_FORMATS.includes(format);

    const canUseFormat = (format) => {

      if (!isPremiumFormat(format)) {
        return true;
      }

      return subscription?.plan_id >= 2;
    };

    const handleFileUpload = (selectedFiles) => {
      const preparedFiles = Array.from(selectedFiles).map((file) => ({
        id: crypto.randomUUID(),
        name: file.name,
        size: `${(file.size / 1024 / 1024).toFixed(2)} MB`,
        from: file.name.split(".").pop().toUpperCase(),
        to: "PDF",
        color: "#2563EB",
        rawFile: file,
      }));

      setFiles(preparedFiles);
    };

    const startConversion = async () => {
      try {
        for (const file of files) {
          const formData = new FormData();

          formData.append("file", file.rawFile);
          formData.append(
            "from_format",
            file.from.toLowerCase()
          );
          formData.append(
            "to_format",
            file.to.toLowerCase()
          );
          formData.append("conversion_type", conversionType);
          formData.append(
            "email_notify",
            emailNotify.toString()
          );

            const currentUser = JSON.parse(
              localStorage.getItem("currentUser")
            );

            if (currentUser?.user_id) {
              formData.append(
                "user_id",
                currentUser.user_id
              );
            }

          const response = await fetch(
            `${API_URL}/convert`,
            {
              method: "POST",
              body: formData,
            }
          );

          const result = await response.json();

          console.log("Conversion Result:", result);

          if (!response.ok) {
            setConversionMessage(
              result.detail || "Conversion failed"
            );

            setDownloadUrl("");

            return;
          }

          setConversionMessage(
            "✅ Conversion completed successfully!"
          );

          setDownloadUrl(result.download_url || "");

          if (autoDownload && result.download_url) {
            const link = document.createElement("a");

            link.href = result.download_url;
            link.download = "";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

  return (
    <main className="nc-main">
      {/* Header */}
      <div>
        <a href="/conversions" className="nc-back-link"><BackIcon /> Back to Conversions</a>
        <div className="nc-page-header">
          <div>
            <h1 className="nc-page-title">New Conversion</h1>
            <p className="nc-page-sub">Upload files and choose your target format to start converting</p>
          </div>
        </div>
      </div>

      {/* Upload Zone */}
      <div
        className={`nc-upload-zone ${isDragging ? "nc-upload-zone--active" : ""}`}
        onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false);

          handleFileUpload(e.dataTransfer.files);
        }}
      >
        <UploadCloudIcon />
        <span className="nc-upload-title">Drag & drop your files here</span>
        <span className="nc-upload-or">or</span>
        <button className="nc-browse-btn" onClick={() => fileInputRef.current?.click()}>
          Browse Files
        </button>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          hidden
          onChange={(e) => handleFileUpload(e.target.files)}
        />
        <span className="nc-upload-formats">
          Supports PDF, DOCX, XLSX, PNG, JPG, MP4, WAV, CSV and 200+ more formats
        </span>
        <span className="nc-upload-limit">Maximum file size: 2GB per file</span>
      </div>

      {/* Selected Files */}
      <div className="nc-card">
        <div className="nc-card-header">
          <h4>Selected Files</h4>
          <p>Configure the target formats for your uploaded items</p>
        </div>
        <div className="nc-divider" />
        {Array.isArray(files) &&
          files.map((file, i) => (
          <React.Fragment key={file.id}>
            <div className="nc-file-row">
              <div className="nc-file-info">
                <div className="nc-file-icon" style={{ background: file.color }}>{file.from[0]}</div>
                <div className="nc-file-details">
                  <span className="nc-file-name">{file.name}</span>
                  <span className="nc-file-size">{file.size}</span>
                </div>
              </div>
              <div className="nc-format-picker">
                <span className="nc-format-badge">{file.from}</span>
                <ArrowIcon />
                <div className="nc-select-wrap">
                  <select
                    className="nc-format-select"
                    value={file.to}
                    onChange={(e) =>
                      updateTarget(file.id, e.target.value)
                    }
                  >
                    {Object.entries(FORMAT_OPTIONS).map(
                      ([category, formats]) => (
                        <optgroup
                          key={category}
                          label={category}
                        >
                          {formats
                            .filter(
                              (format) =>
                                format !== file.from
                            )
                            .map((format) => (
                              <option
                                key={format}
                                value={format}
                                disabled={!canUseFormat(format)}
                              >
                                {!canUseFormat(format)
                                  ? `${format} (Upgrade Required)`
                                  : format}
                              </option>
                            ))}
                        </optgroup>
                      )
                    )}
                  </select>
                  <ChevronDownIcon />
                </div>
                <button className="nc-remove-btn" onClick={() => removeFile(file.id)}>
                  <CloseIcon />
                </button>
              </div>
            </div>
            {i < files.length - 1 && <div className="nc-divider" />}
          </React.Fragment>
        ))}
      </div>

      {/* Conversion Settings */}
      <div className="nc-card">
        <div className="nc-card-header">
          <h4>Conversion Settings</h4>
          <p>Configure output parameters and workspace actions</p>
        </div>
        <div className="nc-divider" />
        <div className="nc-settings-grid">
          <div className="nc-setting-col">
            <div className="nc-setting-field">
              <label className="nc-label">CONVERSION TYPE</label>
              <div className="nc-select-wrap nc-select-full">
                <select
                  className="nc-settings-select"
                  value={conversionType}
                  onChange={(e) =>
                    setConversionType(e.target.value)
                  }
                >
                  {CONVERSION_TYPES.map((option) => (

                    <option
                      key={option.value}
                      value={option.value}
                      disabled={
                        !availableConversions.includes(
                          option.value
                        )
                      }
                    >
                      {
                        !availableConversions.includes(
                          option.value
                        )
                          ? `${option.label} (Upgrade Required)`
                          : option.label
                      }
                    </option>

                  ))}
                </select>
                <ChevronDownIcon />
              </div>

              <p
                className="nc-conversion-description"
                style={{
                  marginTop: "8px",
                  fontSize: "14px",
                  color: "#64748B",
                }}
              >
                {selectedConversionType.description}
              </p>
            </div>
          </div>
          <div className="nc-setting-col">
            <div className="nc-toggle-setting">
              <label className="nc-label">NOTIFICATION</label>
              <div className="nc-toggle-row">
                <Toggle checked={emailNotify} onChange={setEmailNotify} />
                <span>Email me when complete</span>
              </div>
            </div>
            <div className="nc-toggle-setting">
              <label className="nc-label">AUTO-DOWNLOAD</label>
              <div className="nc-toggle-row">
                <Toggle checked={autoDownload} onChange={setAutoDownload} />
                <span>Download files automatically</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {conversionMessage && (
        <div
          style={{
            background: conversionMessage.startsWith("✅")
              ? "#ECFDF5"
              : "#FEF2F2",
            border: conversionMessage.startsWith("✅")
              ? "1px solid #10B981"
              : "1px solid #EF4444",
            color: conversionMessage.startsWith("✅")
              ? "#065F46"
              : "#991B1B",
            padding: "12px",
            borderRadius: "8px",
            marginBottom: "16px",
          }}
        >
          {conversionMessage}
        </div>
      )}

      {downloadUrl && (
        <div
          style={{
            marginBottom: "16px",
          }}
        >
        <a
              href={downloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              >
            Download Converted File
          </a>
        </div>
      )}

      {/* Action Bar */}
      <div className="nc-action-bar">
        <div className="nc-action-info">
          <InfoIcon />
          <span>{files.length} files selected · Estimated time: ~2 minutes</span>
        </div>
        <div className="nc-action-btns">
          <button className="nc-btn-outline">Cancel</button>
          <button className="nc-btn-start" onClick={startConversion}><PlayIcon /> Start Conversion</button>
        </div>
      </div>
    </main>
  );
}

/* ─── Page ─── */
export default function ConvertProNewConversion() {
  return (
    <div className="nc-layout">
      <Sidebar />
      <MainContent />
    </div>
  );
}
